import React, { Component, Fragment } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Typography, Grid, Button, TextField, Table, TableBody, TableCell, TableRow, FormControlLabel, TableHead, Checkbox, Tabs, Tab } from '@material-ui/core';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import PropTypes from 'prop-types';
import PaddedGrid from '../components/PaddedGrid';
import APIService from '../services/APIService';
import Loading from '../components/Loading';
import RestaurantType from '../constants/RestaurantType';
import AppContext from '../AppContext';
import MenuImporter from '../components/MenuImporter';
import MenuRemover from '../components/MenuRemover';
import { withTranslation } from 'react-i18next';
import FeedbackQuestions from './FeedbackQuestions';

class Organisation extends Component {
    constructor(props) {
        super(props);

        this.organisationId = props.match.params.organisationId;

        this.state = Object.assign(
            {},
            props.location.state,
            {
                redirect: false,
                loading: true,
                selectedRestaurants: [],
                search: '',
                selectAll: false,
                tabIndex: 0,
            }
        );

        this.createChangeEventHandler = this.createChangeEventHandler.bind(this);
        this.filterBySearch = this.filterBySearch.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }

    save() {
        const { organisation } = this.state;

        APIService.updateOrganisation(organisation.id, organisation)
            .then(() => {
                AppContext.toast(this.props.t('Organisaation tiedot tallennettu onnistuneesti!'));
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    destroy() {
        APIService.destroyOrganisation(this.organisationId)
            .then(() => {
                this.setState({ redirect: true });
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    createChangeEventHandler(field) {
        return (event) => {
            let organisation = this.state.organisation;

            let value = event.target.value;
            if (event.target.attributes && event.target.attributes.type.textContent === 'checkbox') {
                value = event.target.checked;
            }

            organisation[field] = value;
            this.setState({ organisation });
        };
    }

    componentDidMount() {
        APIService.getOrganisation(this.organisationId)
            .then((organisation) => {
                this.setState({
                    organisation,
                    loading: false
                });
            }).catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    selectRestaurant(restaurantId, ev, forceState) {
        if (ev) {
            ev.stopPropagation();
        }

        let selectedRestaurants = this.state.selectedRestaurants;
        const index = selectedRestaurants.indexOf(restaurantId);

        if (index !== -1 && forceState !== true) {
            selectedRestaurants.splice(index, 1);
        } else if (index === -1 && forceState !== false) {
            selectedRestaurants.push(restaurantId);
        }

        this.setState({ selectedRestaurants });
    }

    filterBySearch() {
        if (!this.state.search || this.state.search.length < 1) {
            return this.state.organisation.restaurants;
        }


        const restaurants = this.state.organisation.restaurants.filter(restaurant => restaurant.name.toLowerCase().includes(this.state.search.toLowerCase()));
        return restaurants;
    }

    selectAll() {
        const visibleRestaurants = this.filterBySearch();
        visibleRestaurants.forEach(restaurant => this.selectRestaurant(restaurant.id, null, !this.state.selectAll));

        this.setState({ selectAll: !this.state.selectAll });
    }

    renderFeedbackQuestions() {
        if (!AppContext.isAdmin() && !AppContext.isOrganisation()) {
            return;
        }

        return <FeedbackQuestions organisationId={this.state.organisation.id} />;
    }

    render() {
        const { organisation } = this.state;

        if (this.state.redirect) {
            return <Redirect to="/organisations" />;
        }

        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <PaddedGrid>
                <Button component={Link} to={AppContext.isAdmin() ? "/organisations" : "/"}>{this.props.t('Takaisin')}</Button>

                <Grid item xs={12}>
                    <Typography variant="display1">{organisation.name}</Typography>
                </Grid>

                <Tabs
                    value={this.state.tabIndex}
                    onChange={(_event, value) => this.setState({ tabIndex: value })}
                    textColor="#000000"
                    TabIndicatorProps={{ style: { backgroundColor: "#000000" } }} // Custom indicator color
                    style={{ marginBottom: '2rem', marginTop: '2rem', width: '100%', borderBottom: '1px solid lightgray' }}
                >
                    <Tab label={this.props.t('Toimipaikat')} />
                    <Tab label={this.props.t('Palaute')} />
                </Tabs>
                {this.state.tabIndex === 0 && (
                    <Fragment>
                        <Grid item xs={12}>
                            <Typography variant="subheading">{this.props.t('Etsi toimipaikka')}</Typography>
                            <TextField
                                fullWidth
                                label={this.props.t('Toimipaikan nimi')}
                                value={this.state.search}
                                onChange={(event) => this.setState({ search: event.target.value, selectAll: false })} />
                        </Grid>
                        {AppContext.isAdmin() &&
                            <Grid item xs={12}>
                                <Typography variant="subheading">{this.props.t('Käyttäjä')}</Typography>
                                <TextField
                                    fullWidth
                                    value={organisation.user.email}
                                    label={this.props.t('Sähköposti')}
                                    disabled
                                />

                                <TextField
                                    fullWidth
                                    type="password"
                                    label={this.props.t('Uusi salasana')}
                                    value={organisation.password}
                                    onChange={this.createChangeEventHandler('password')}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={organisation.export_disabled == true}
                                            onChange={this.createChangeEventHandler('export_disabled')}
                                        />
                                    }
                                    label={this.props.t('Estä raporttien vienti organisaatiolta sekä siihen kuuluvilta toimipaikoilta')} />


                                <Grid container spacing={24} style={{ margin: '5px 0' }}>
                                    <Button
                                        variant="raised"
                                        color="primary"
                                        onClick={() => this.save()}
                                        style={{ marginRight: '5px' }}
                                    >
                                        {this.props.t('Tallenna')}
                                    </Button>

                                    <Button
                                        variant="raised"
                                        color="secondary"
                                        onClick={() => AppContext.prompt(() => this.destroy())}
                                    >
                                        {this.props.t('Poista')}
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Toimipaikat')}</Typography>
                            <div style={{ marginTop: '20px' }}>
                                <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({ showImportModal: true })}>{this.props.t('Lisää ruokalista valittuihin toimipisteisiin')}</Button>
                                <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({ showRemoveModal: true })}>{this.props.t('Poista ruokalistoja valituista toimipisteistä')}</Button>
                            </div>
                            <Table>
                                <TableHead>
                                    <TableCell style={{ width: '40px' }}>
                                        <Checkbox
                                            checked={this.state.selectAll}
                                            onClick={this.selectAll} />
                                    </TableCell>
                                    <TableCell>{this.props.t('Toimipaikan nimi')}</TableCell>
                                    <TableCell>{this.props.t('Tyyppi')}</TableCell>
                                    <TableCell></TableCell>
                                </TableHead>

                                <TableBody>
                                    {this.filterBySearch().map(restaurant =>
                                        <TableRow key={restaurant.id}
                                            component={Link}
                                            to={{
                                                pathname: `/restaurants/${restaurant.id}`
                                            }}
                                            style={{ textDecoration: 'none' }}>
                                            <TableCell style={{ width: '40px' }}>
                                                <Checkbox
                                                    checked={this.state.selectedRestaurants.indexOf(restaurant.id) !== -1}
                                                    onClick={(ev) => this.selectRestaurant(restaurant.id, ev)} />
                                            </TableCell>

                                            <TableCell>{restaurant.name}</TableCell>
                                            <TableCell>{this.props.t(RestaurantType[restaurant.type])}</TableCell>
                                            <TableCell style={{ textAlign: 'right' }}>
                                                <KeyboardArrowRight />
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                            <MenuImporter
                                open={this.state.showImportModal}
                                restaurantId={this.state.selectedRestaurants}
                                onClose={() => this.setState({ showImportModal: false })}
                            />

                            <MenuRemover
                                open={this.state.showRemoveModal}
                                restaurantIds={this.state.selectedRestaurants}
                                onClose={() => this.setState({ showRemoveModal: false })}
                            />

                            <div style={{ marginTop: '20px' }}>
                                <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({ showImportModal: true })}>{this.props.t('Lisää ruokalista valittuihin toimipisteisiin')}</Button>
                                <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({ showRemoveModal: true })}>{this.props.t('Poista ruokalistoja valituista toimipisteistä')}</Button>
                            </div>
                        </Grid>
                    </Fragment>
                )}
                {this.state.tabIndex === 1 && (
                    <Fragment>
                        {this.renderFeedbackQuestions()}
                    </Fragment>
                )}
            </PaddedGrid>
        );
    }
}

Organisation.propTypes = {
    location: PropTypes.object.isRequired
};

export default withTranslation()(Organisation);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Organisation.js